<div class="page-loader" [class.active]="active">
    <img src="assets/images/gorilla-logo-kerek.svg" alt="Gorilla S10">
    <img src="assets/images/page_loader.svg" alt="Loading...">
</div>
